<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="购销计划">
          <el-input
            v-model="query.goodsCode"
            placeholder="请输入购销计划"
          />
        </el-form-item>
        <el-form-item label="客户号">
          <el-input
            v-model="query.tradeUserAccount"
            placeholder="请输入客户号"
          />
        </el-form-item>
        <el-form-item
          label="结算日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始结算日期"
            end-placeholder="截止结算日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="tradingDate"
        label="结算日期"
      />
      <af-table-column
        fixed
        prop="signHoldDate"
        label="成交日期"
      />
      <af-table-column
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="goodsCodeOther"
        label="套利购销计划"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="holdAmount"
        label="订货量"
      />
      <af-table-column
        prop="holdPrice"
        label="订货价"
      />
      <af-table-column
        prop="lockedFrozen"
        label="锁仓量"
      />
      <af-table-column
        prop="frozenAmount"
        label="冻结量"
      />
      <af-table-column
        prop="frozenBailBalance"
        label="基本担保履约资金"
      />
      <af-table-column
        prop="holdGainLoss"
        label="补充担保履约资金"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'

function Query () {
  this.marketId = '000' // 组织编号
  this.goodsCode = '' // 购销计划
  this.tradeUserAccount = '' // 客户号
  this.date = [] // 结算日期
}
export default {
  name: 'HistoricalArbitrageOrderDetailInquiry',
  data () {
    return {
      query: new Query(),

      currentPage: 1,
      total: 0,
      pageSize: 10,
      marketId: '',
      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.signHoldDateBegin = this.query.date.length ? dayJs(this.query.date[0]).format('YYYYMMDD') : ''
      param.signHoldDateEnd = this.query.date.length ? dayJs(this.query.date[1]).format('YYYYMMDD') : ''
      let res = await api.spotPurchaseSaleInquiry.HistoricalArbitrageOrderDetailInquiry(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 导出
    toDownload () {
      let param = {
        marketId: this.marketId,
        execlType: '08',
        excelHead: [
          // {
          //   fieldLabel: '组织',
          //   excelColumn: 'marketName'
          // },
          {
            fieldLabel: '结算日期',
            excelColumn: 'tradingDate'
          },
          {
            fieldLabel: '成交日期',
            excelColumn: 'signHoldDate'
          },
          {
            fieldLabel: '客户',
            excelColumn: 'userAccount'
          },
          {
            fieldLabel: '客户号',
            excelColumn: 'tradeUserAccount'
          },
          {
            fieldLabel: '客户名称',
            excelColumn: 'userName'
          },
          {
            fieldLabel: '区域',
            excelColumn: 'areaName'
          },
          {
            fieldLabel: '订货量',
            excelColumn: 'holdAmount'
          },
          {
            fieldLabel: '订货价',
            excelColumn: 'holdPrice'
          },
          {
            fieldLabel: '锁仓量',
            excelColumn: 'lockedFrozen'
          },
          {
            fieldLabel: '冻结量',
            excelColumn: 'frozenAmount'
          },
          {
            fieldLabel: '基本担保履约资金',
            excelColumn: 'frozenBailBalance'
          },
          {
            fieldLabel: '补充担保履约资金',
            excelColumn: 'holdGainLoss'
          },
        ]
      }
      this.$utils.getExcelFile(this, api.download, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
<style lang="scss" scoped>
  .hideTotal ::v-deep .el-table__fixed .el-table__fixed-body-wrapper tbody>tr:last-child td:nth-child(2) div,
  .hideTotal ::v-deep .el-table__fixed .el-table__fixed-body-wrapper tbody>tr:last-child td:nth-child(3) div {
    display: none;
  }

</style>
